export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/index.js